import React, { useEffect, useRef, useState } from 'react';
import Platform1 from '../Assets/Imgs/Platform1.png';
import Platform2 from '../Assets/Imgs/Platform2.png';
import Platform3 from '../Assets/Imgs/Platform3.png';
import Platform3Active from '../Assets/Imgs/Platform3Active.png';
import Terminal from '../Components/Common/Terminal';
import './Level1.css'
import Spikes from '../Components/Common/Spikes';
import TerminalActive from '../Assets/Imgs/Terminal.png'
import TerminalInactive from '../Assets/Imgs/TerminalActive.png'
import Pause from '../Assets/Icons/Pause.svg'

import SpikesActive from '../Assets/Imgs/SpikesActive.png'
import SpikesInactive from '../Assets/Imgs/SpikesInactive.png'
import LoseScreen from '../Components/Layout/LoseScreen';
import WinScreen from '../Components/Layout/WinScreen';
import Btn from '../Components/Common/Btn';
import PauseMenu from '../Components/Layout/PauseMenu';

import Char1 from '../Assets/Imgs/Char1.png';
import Char2 from '../Assets/Imgs/Char2.png';
import Char3 from '../Assets/Imgs/Char3.png';

const Level1 = () => {

    const CharImgs = [Char1, Char2, Char3];

    const START_X = 100;
    const START_Y = 700;

    const [pos, setPos] = useState({ x: 100, y: 700 }); 
    const velocity = useRef({ x: 0, y: 0 });
    const keysPressed = useRef({});

    const [isDead, setIsDead] = useState(false);
    const [isWon, setIsWon] = useState(false);
    const [isPaused, setIsPaused] = useState(false);

    const [currentFrame, setCurrentFrame] = useState(0);
    const frameTimer = useRef(0);
    const animationDirection = useRef(1); 
    const [isFacingLeft, setIsFacingLeft] = useState(false);

    const [terminalsHacked, setTerminalsHacked] = useState({ t1: false, t2: false });
    const [nearTerminals, setNearTerminals] = useState({ t1: false, t2: false });

    const GRAVITY = 0.1;
    const MOVE_SPEED = 5;
    const JUMP_FORCE = -13;

    const GROUND_HEIGHT = 200;
    const CHAR_WIDTH = 100;
    const CHAR_HEIGHT = 180;

  const PLATFORMS_CONFIG = [
    { 
        width: 732, 
        height: 380, 
        left: -20, 
        right: null, 
        top: null,
        bottomOffset: 170 
    },
    { 
        width: 600, 
        height: 370, 
        left: null, 
        right: -50, 
        top: null,
        bottomOffset: 170 
    },
    { 
        width: 350, 
        height: 90, 
        left: null, 
        right: -100, 
        top: 280,    
        bottomOffset: null 
    }
];

   
const platforms = PLATFORMS_CONFIG.map(plat => {

    let absoluteLeft;
    if (plat.left !== null) {
        absoluteLeft = plat.left;
    } else {
        
        absoluteLeft = window.innerWidth + plat.right - plat.width;
    }

    let absoluteTop;
    if (plat.top !== null) {
        absoluteTop = plat.top; 
    } else {
    
        absoluteTop = window.innerHeight - (plat.bottomOffset + plat.height);
    }

    return {
        left: absoluteLeft,
        right: absoluteLeft + plat.width,
        top: absoluteTop
    };
});

    const SPIKES_CONFIG = [
        { width: 153, height: 127.174, right: 620, bottom: 150 },
        { width: 153, height: 127.174, right: 320, bottom: 190 }  
    ];

    const spikes = SPIKES_CONFIG.map(spike => {
        let absoluteLeft = window.innerWidth - spike.right - spike.width;
        let absoluteTop = window.innerHeight - spike.bottom - spike.height;
        return {
            left: absoluteLeft,
            right: absoluteLeft + spike.width,
            top: absoluteTop,
            bottom: absoluteTop + spike.height
        };
    });

    const TERMINAL_1_BOX = { left: 31, top: 356, width: 100, height: 181 };

    const t2Width = 100;
        const t2Height = 181;
        const t2AbsoluteLeft = window.innerWidth - 31 - t2Width;
        const t2AbsoluteTop = window.innerHeight - 196 - t2Height;
        const TERMINAL_2_BOX = { left: t2AbsoluteLeft, top: t2AbsoluteTop, width: t2Width, height: t2Height };

    const WIN_ZONE = {
        left: window.innerWidth - 30 - 100,
        top: 100,
        width: 100,
        height: 190
    };
    
    
        const handleRetry = () => {
        velocity.current = { x: 0, y: 0 }; 
        keysPressed.current = {};          
        setPos({ x: START_X, y: START_Y });
        setIsDead(false);                  
    };

    const handleTerminalClick = (terminalId) => {
        if (nearTerminals[terminalId]) {
            setTerminalsHacked(prev => ({ ...prev, [terminalId]: true }));
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => { keysPressed.current[e.key.toLowerCase()] = true; };
        const handleKeyUp = (e) => { keysPressed.current[e.key.toLowerCase()] = false; };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        let animationFrameId;

        const updateGame = () => {
            setPos((prevPos) => {
                if (isDead || isWon) return prevPos;
                let nextX = prevPos.x;
                let nextY = prevPos.y;

                const movingLeft = keysPressed.current['a'];
                const movingRight = keysPressed.current['d'];
                const isMoving = movingLeft || movingRight;

                if (movingLeft) {
                    velocity.current.x = -MOVE_SPEED;
                    setIsFacingLeft(true);
                } else if (movingRight) {
                    velocity.current.x = MOVE_SPEED;
                    setIsFacingLeft(false);
                } else {
                    velocity.current.x = 0;
                }

                if (keysPressed.current['a']) velocity.current.x = -MOVE_SPEED;
                else if (keysPressed.current['d']) velocity.current.x = MOVE_SPEED;
                else velocity.current.x = 0;

                if (isMoving) {
                    frameTimer.current += 1;
                    // Adjust '30' to make his legs step faster or slower
                    if (frameTimer.current >= 20) {
                        setCurrentFrame((prevFrame) => {
                            // 1. Calculate what the next frame *would* be
                            let nextFrame = prevFrame + animationDirection.current;
                            
                            // 2. If it tries to go past the last frame (index 2), snap it back to 1 and reverse
                            if (nextFrame > 2) {
                                animationDirection.current = -1;
                                return 1; 
                            }
                            // 3. If it tries to go below the first frame (index 0), snap it back to 1 and reverse forward
                            if (nextFrame < 0) {
                                animationDirection.current = 1;
                                return 1;
                            }
                            
                            return nextFrame;
                        });
                        frameTimer.current = 0;
                    }
                } else {
                    // Instantly snap back to standing idle pose (Char1) when motionless
                    setCurrentFrame(0);
                    frameTimer.current = 0;
                    animationDirection.current = 1;
                }


                velocity.current.y += GRAVITY;

                nextX += velocity.current.x;
                nextY += velocity.current.y;

                const charCenterX = nextX + (CHAR_WIDTH / 2);

                
                // for Terminal
                const t1CenterX = TERMINAL_1_BOX.left + (TERMINAL_1_BOX.width / 2);
                const distanceT1X = Math.abs(charCenterX - t1CenterX);
                const nearT1 = (distanceT1X < 120) && 
                               (nextY + CHAR_HEIGHT > TERMINAL_1_BOX.top) && 
                               (nextY < TERMINAL_1_BOX.top + TERMINAL_1_BOX.height);

                const t2CenterX = TERMINAL_2_BOX.left + (TERMINAL_2_BOX.width / 2);
                const distanceT2X = Math.abs(charCenterX - t2CenterX);
                const nearT2 = (distanceT2X < 120) && 
                               (nextY + CHAR_HEIGHT > TERMINAL_2_BOX.top) && 
                               (nextY < TERMINAL_2_BOX.top + TERMINAL_2_BOX.height);

                setNearTerminals({ t1: nearT1, t2: nearT2 });

                //for Spikes

                if (!terminalsHacked.t1) {
                    spikes.forEach(spike => {
                        const overlapX = (nextX + CHAR_WIDTH > spike.left) && (nextX < spike.right);
                        const overlapY = (nextY + CHAR_HEIGHT > spike.top) && (nextY < spike.bottom);
                        if (overlapX && overlapY) setIsDead(true);
                    });
                }

                //for winning

                const overlapWinX = (nextX + CHAR_WIDTH > WIN_ZONE.left) && (nextX < WIN_ZONE.left + WIN_ZONE.width);
                const overlapWinY = (nextY + CHAR_HEIGHT > WIN_ZONE.top) && (nextY < WIN_ZONE.top + WIN_ZONE.height);

                if (overlapWinX && overlapWinY && terminalsHacked.t1 && terminalsHacked.t2) {
                    setIsWon(true);
                }

                //Platform Collision
                let isGrounded = false;
                const groundTop = window.innerHeight - GROUND_HEIGHT;

                platforms.forEach(plat => {
                    const withinPlatformX = (nextX + CHAR_WIDTH > plat.left) && (nextX < plat.right);
                    const landingOnPlatform = (prevPos.y + CHAR_HEIGHT <= plat.top) && (nextY + CHAR_HEIGHT >= plat.top);

                    if (withinPlatformX && landingOnPlatform && velocity.current.y >= 0) {
                        nextY = plat.top - CHAR_HEIGHT;
                        velocity.current.y = 0;
                        isGrounded = true;
                    }
                });


                if (nextY + CHAR_HEIGHT >= groundTop) {
                    nextY = groundTop - CHAR_HEIGHT;
                    velocity.current.y = 0;
                    isGrounded = true;
                }

                if (isGrounded && (keysPressed.current['w'] || keysPressed.current[' '])) {
                    velocity.current.y = JUMP_FORCE;
                }


                if (nextX < 0) nextX = 0;
                if (nextX > window.innerWidth - CHAR_WIDTH) nextX = window.innerWidth - CHAR_WIDTH;

                return { x: nextX, y: nextY };
            });

            animationFrameId = requestAnimationFrame(updateGame);
        };

        animationFrameId = requestAnimationFrame(updateGame);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
            cancelAnimationFrame(animationFrameId);
        };
    }, [platforms, spikes, isDead, terminalsHacked, nearTerminals]);

    return ( 
        <main className='Level1Main'>
            <div 
                className='Character' 
                style={{ 
                    left: `${pos.x}px`, 
                    top: `${pos.y}px`,
                    transform: isFacingLeft ? 'scaleX(-1)' : 'scaleX(1)'
                }}
            >
                <img className='CharacterImg' src={CharImgs[currentFrame]} alt="Character" />
            </div>

            <div className='Platform1'>
                <img src={Platform1} alt="Platform Structure 1" />
            </div>

            <Terminal 
                TerminalStyle={`Terminal1 ${nearTerminals.t1 ? 'Interactable' : ''} ${terminalsHacked.t1 ? 'Disabled' : ''}`}
                onClick={() => handleTerminalClick('t1')}
                TerminalImg={terminalsHacked.t1 ? TerminalInactive : TerminalActive}
            />
            <Terminal 
                TerminalStyle={`Terminal2 ${nearTerminals.t2 ? 'Interactable' : ''} ${terminalsHacked.t2 ? 'Disabled' : ''}`}
                onClick={() => handleTerminalClick('t2')}
                TerminalImg={terminalsHacked.t2 ? TerminalInactive : TerminalActive}
            />

            <Spikes SpikesImg={terminalsHacked.t1 ? SpikesInactive : SpikesActive} SpikesStyle={terminalsHacked.t1 ? 'SpikesInactive1' : 'SpikesActive1'}/>
            <Spikes SpikesImg={terminalsHacked.t1 ? SpikesInactive : SpikesActive} SpikesStyle={terminalsHacked.t1 ? 'SpikesInactive2' : 'SpikesActive2'}/>

            <div className='Platform2'>
                <img src={Platform2} alt="Platform Structure 2" />
            </div>

            <div className='Platform3'>
                <img src={terminalsHacked.t2 ? Platform3Active : Platform3} alt="Platform Structure 3" />
            </div>

            <div className='Ground'></div>

            {isDead && (
                <div className="LoseScreenContainer">
                    <LoseScreen RetryClick={handleRetry} />
                </div>
            )}

            {isWon && (
                <div className="LoseScreenWrapper"> 
                    <WinScreen RetryClick={handleRetry} LevelPath="/fix" />
                </div>
            )}

            <div className='WinZone'></div>

            <Btn BtnIcon={Pause} BtnStyle="PauseBtn" onClick={() => setIsPaused(true)}/>
            {isPaused && <PauseMenu ResumeClick={()=>setIsPaused(false)}/>}
        </main>
     );
}
 
export default Level1;